import styled from "@emotion/styled";
import dynamic from "next/dynamic";

const QRCode = dynamic(() => import("qrcode.react"), {
    ssr: false, loading: () => <div
        style={{
            width: 90,
            height: 90,
            flexShrink: 0,
        }}
    />
});

const StyledQRWrapper = styled.div`

    ${(props) => props.theme.breakpoints.up("md")} {
        width: 320px;
        height:  90px;
        padding: 16px;
        border-radius: 8px;
        opacity: 0px;
        background-color: white;
        display: flex;
        align-items: center;
        gap: 10px;
        flex-direction: row;
    }
    ${(props) => props.theme.breakpoints.up("lg")} {
       width: 357px;
    }
`
const StyledText = styled.span`
font-size: 18px;
font-weight: 500;
line-height: 20px;
color:  #0068C9;
`
type QRCodeLayoutProps = {
    text?: string | undefined,
    url?: string
}
const QRCodeInMapCharge = ({ text, url = "" }: QRCodeLayoutProps) => {
    return (
        <>
            <StyledQRWrapper>
                <QRCode
                    value={url}
                    size={90}
                    bgColor="white"
                    fgColor="#0068C9"
                    level="M"
                    includeMargin={true}
                />
                <StyledText>
                    {text || "סרקו להורדת האפליקציה ותתחילו להטעין"}
                </StyledText>
            </StyledQRWrapper>
        </>
    )
}
export default QRCodeInMapCharge;
